export default "__VITE_ASSET__CtUOpcWj__"